import { render, staticRenderFns } from "./RistampaSeriali.vue?vue&type=template&id=3650c779&scoped=true&"
import script from "./RistampaSeriali.vue?vue&type=script&lang=js&"
export * from "./RistampaSeriali.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3650c779",
  null
  
)

export default component.exports